export { monetizationTransferPageRedirect } from '@goeuro/app/client/tracking-provider/src/cms/lib/events/__events__/monetizationTransferPageRedirect';
export type { MonetizationTransferPageRedirectProperties } from '@goeuro/app/client/tracking-provider/src/cms/lib/events/__events__/monetizationTransferPageRedirect';
